import styled from "styled-components"
import { media, theme } from "../../theme/theme"
import { V3BodyGrey48 } from "../ReusableStyledComponents/V3BodyGrey48";
import { V3HeadlineH4, V3HeadlineH5 } from "../Typography";
import { ClampMixin, ClampMixinType } from "../ReusableStyledComponents/ClampMixin";

export const CONTENT_SHORT_DATE = 600;
const MOBILE_BR = 1150;

export const TitleMetaWrapper = styled.div<{ $isSelectOnly: boolean}>`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: calc(100% - 85px);
    align-items: center;
    user-select: ${({ $isSelectOnly }) => $isSelectOnly ? "none" : undefined };

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        max-width: calc(100% - 115px);
    }

    ${media.custom(MOBILE_BR)} {
        flex-wrap: ${({ $isSelectOnly }) => !$isSelectOnly ? "nowrap" : undefined };
    }

    > div {
        &:nth-child(1) {
            width: 100%;
            margin-bottom: 6px;
            margin-right: 0;

            ${media.custom(MOBILE_BR)} {
                margin-bottom:  ${({ $isSelectOnly }) => $isSelectOnly ? "6px" : "0px" };
                margin-right: 18px;
            }
        }

        &:nth-child(2) {
            margin-right: 18px;
            ${media.custom(MOBILE_BR)} {
                width: 100px;
            }
        }

        &:nth-child(3) {
            text-align: left;
            max-width: calc(100% - 75px);

            ${media.custom(CONTENT_SHORT_DATE)} {
                max-width: calc(100% - 115px);
            }

            ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
                max-width: calc(100% - 140px);
            }
            
            ${media.custom(MOBILE_BR)} {
                max-width: 230px;
                width: 25%;
            }
        }

        &:nth-child(2),
        &:nth-child(3) {
            ${media.custom(MOBILE_BR)} {
                flex-shrink: 0;
            }
        }
    }
`;

export const CLTitle = styled(V3HeadlineH4) <ClampMixinType>`
    ${ClampMixin};
`;

export const CLTitleSelectOnly = styled(V3HeadlineH5) <ClampMixinType>`
    ${ClampMixin};
`;

export const CLSourceLabel = styled(V3BodyGrey48)`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: calc(100%);
`;

export const ItemListWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;